import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"

// Cleave.js - format your <input/> content when you are typing

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    const config = this.optionsValue || {}
    this.cleave = new Cleave(this.element, config)
  }

  disconnect() {
    if (this.cleave) this.cleave.destroy()
  }
}
